// interlinked-tdd: exempt
// Curated MCP server catalog — Genomics portal. Hand-maintained data; add new
// servers here. Split out of curated-servers.ts to stay under the file-size cap.
import type { CuratedServer } from "./types";

export const GENOMICS_SERVERS: CuratedServer[] = [
  {
    key: "alphafold",
    name: "AlphaFold DB",
    type: "streamable-http",
    url: "https://alphafold-mcp-server.quentincody.workers.dev/mcp",
    description: "AlphaFold Protein Structure Database — pre-computed predicted structures for 200M+ proteins by UniProt accession",
    theme: "genomics",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "bgee",
    name: "Bgee SPARQL",
    type: "streamable-http",
    url: "https://bgee-mcp-server.quentincody.workers.dev/mcp",
    description: "Bgee SPARQL — healthy wild-type animal gene expression across tissues, ontology-aware.",
    theme: "genomics",
    category: "expression",
    defaultEnabled: true,
  },
  {
    key: "biogrid",
    name: "BioGRID",
    type: "streamable-http",
    url: "https://biogrid-mcp-server.quentincody.workers.dev/mcp",
    description: "BioGRID — curated experimentally validated protein-protein, genetic, and chemical-protein interactions across…",
    theme: "genomics",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "biothings",
    name: "BioThings",
    type: "streamable-http",
    url: "https://biothings-mcp-server.quentincody.workers.dev/mcp",
    description: "BioThings entity resolution — batch ID mapping for genes (MyGene.info), variants (MyVariant.info), and…",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "cellxgene",
    name: "CELLxGENE",
    type: "streamable-http",
    url: "https://cellxgene-mcp-server.quentincody.workers.dev/mcp",
    description: "CZI CELLxGENE Discover — single-cell transcriptomics collections, datasets, and assays.",
    theme: "genomics",
    category: "expression",
    defaultEnabled: true,
  },
  {
    key: "clingen",
    name: "ClinGen",
    type: "streamable-http",
    url: "https://clingen-mcp-server.quentincody.workers.dev/mcp",
    description: "ClinGen — gene-disease validity classifications, dosage sensitivity (HI/TS scores), clinical actionability",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "clinpgx",
    name: "ClinPGx",
    type: "streamable-http",
    url: "https://clinpgx-mcp-server.quentincody.workers.dev/mcp",
    description: "ClinPGx (formerly PharmGKB) — CPIC/DPWG dosing guidelines, clinical annotations, drug labels (FDA/EMA/PMDA)…",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "clinvar",
    name: "ClinVar",
    type: "streamable-http",
    url: "https://clinvar-mcp-server.quentincody.workers.dev/mcp",
    description: "NCBI ClinVar — variant pathogenicity classifications, gene-level variant summaries, clinical significance…",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "decipher",
    name: "DECIPHER",
    type: "streamable-http",
    url: "https://decipher-mcp-server.quentincody.workers.dev/mcp",
    description: "DECIPHER — gene HI/TS scores and constraint metrics, CNV syndrome mapping, open-access patient…",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "encode",
    name: "ENCODE",
    type: "streamable-http",
    url: "https://encode-mcp-server.quentincody.workers.dev/mcp",
    description: "ENCODE Portal — functional genomics experiments, files, biosamples, annotations.",
    theme: "genomics",
    category: "expression",
    defaultEnabled: true,
  },
  {
    key: "ensembl",
    name: "Ensembl",
    type: "streamable-http",
    url: "https://ensembl-mcp-server.quentincody.workers.dev/mcp",
    description: "Ensembl genome browser — gene/transcript lookup, VEP variant annotation, sequence retrieval, cross-references",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "epigraphdb",
    name: "EpiGraphDB",
    type: "streamable-http",
    url: "https://epigraphdb-mcp-server.quentincody.workers.dev/mcp",
    description: "EpiGraphDB — Mendelian randomization + ontology + gene/drug/literature/network endpoints.",
    theme: "genomics",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "eqtl",
    name: "eQTL Catalogue",
    type: "streamable-http",
    url: "https://eqtl-catalogue-mcp-server.quentincody.workers.dev/mcp",
    description: "EBI eQTL Catalogue — quantitative trait loci across studies, tissues, and quantification methods.",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "esmfold",
    name: "ESM Atlas",
    type: "streamable-http",
    url: "https://esmfold-mcp-server.quentincody.workers.dev/mcp",
    description: "ESM Metagenomic Atlas — precomputed protein structures (Atlas-only; live folding deferred).",
    theme: "genomics",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "eva",
    name: "EVA",
    type: "streamable-http",
    url: "https://eva-mcp-server.quentincody.workers.dev/mcp",
    description: "EBI European Variation Archive — variant-level metadata and submitted variants across cohorts.",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "gnomad",
    name: "gnomAD",
    type: "streamable-http",
    url: "https://gnomad-mcp-server.quentincody.workers.dev/mcp",
    description: "gnomAD database — variant population frequencies, gene constraint (pLI/LOEUF), in-silico predictors (CADD…",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "gtex",
    name: "GTEx",
    type: "streamable-http",
    url: "https://gtex-mcp-server.quentincody.workers.dev/mcp",
    description: "GTEx Portal — tissue-specific gene expression, eQTL associations, median expression across 54 tissues",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "gwas-catalog",
    name: "GWAS Catalog",
    type: "streamable-http",
    url: "https://gwas-catalog-mcp-server.quentincody.workers.dev/mcp",
    description: "EBI GWAS Catalog — genome-wide association studies, variant-trait associations, SNPs, genes, and EFO traits",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "hpa",
    name: "Human Protein Atlas",
    type: "streamable-http",
    url: "https://hpa-mcp-server.quentincody.workers.dev/mcp",
    description: "Human Protein Atlas — tissue expression (44 tissues), subcellular localization, pathology, cancer prognostics…",
    theme: "genomics",
    category: "genomics",
    defaultEnabled: true,
  },
  {
    key: "allele-registry",
    name: "ClinGen Allele Registry",
    type: "streamable-http",
    url: "https://allele-registry-mcp-server.quentincody.workers.dev/mcp",
    description: "ClinGen Allele Registry — canonical allele identity (CA#) for variants; resolves HGVS/dbSNP/ClinVar/gnomAD to a stable ID + cross-refs",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "cellosaurus",
    name: "Cellosaurus",
    type: "streamable-http",
    url: "https://cellosaurus-mcp-server.quentincody.workers.dev/mcp",
    description: "Cellosaurus — cell-line knowledge resource: CVCL_ lookup, search, cross-refs to CCLE/DepMap, Cosmic, ATCC",
    theme: "genomics",
    category: "cell lines & models",
    defaultEnabled: true,
  },
  {
    key: "interpro",
    name: "InterPro",
    type: "streamable-http",
    url: "https://interpro-mcp-server.quentincody.workers.dev/mcp",
    description: "InterPro — protein family, domain, and functional-site classification (Pfam, SMART, PROSITE, CDD, PANTHER, and…",
    theme: "genomics",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "ipd-hla",
    name: "IPD-IMGT/HLA",
    type: "streamable-http",
    url: "https://ipd-hla-mcp-server.quentincody.workers.dev/mcp",
    description: "IPD-IMGT/HLA — 45,000+ HLA alleles with sequences, nomenclature, and metadata. MongoDB-style query syntax for…",
    theme: "genomics",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "jaspar",
    name: "JASPAR",
    type: "streamable-http",
    url: "https://jaspar-mcp-server.quentincody.workers.dev/mcp",
    description: "JASPAR — curated transcription factor binding profiles (PWMs / PFMs) across vertebrates, insects, plants, and more.",
    theme: "genomics",
    category: "expression",
    defaultEnabled: true,
  },
  {
    key: "l2g",
    name: "Locus-to-Gene Mapper",
    type: "streamable-http",
    url: "https://l2g-mapper-mcp-server.quentincody.workers.dev/mcp",
    description: "Synchronous 3-tier locus-to-gene mapper — gather/score/synthesize via Code Mode + parallel upstream fan-out.",
    theme: "genomics",
    category: "genomics",
    defaultEnabled: true,
  },
  {
    key: "metabolights",
    name: "MetaboLights",
    type: "streamable-http",
    url: "https://metabolights-mcp-server.quentincody.workers.dev/mcp",
    description: "EBI MetaboLights — metabolomics studies (MTBLS), assays, samples, factors, descriptors.",
    theme: "genomics",
    category: "metabolomics",
    defaultEnabled: true,
  },
  {
    key: "mgnify",
    name: "MGnify",
    type: "streamable-http",
    url: "https://mgnify-mcp-server.quentincody.workers.dev/mcp",
    description: "EBI MGnify — metagenomics studies, samples, analyses, biomes.",
    theme: "genomics",
    category: "metabolomics",
    defaultEnabled: true,
  },
  {
    key: "monarch",
    name: "Monarch Initiative",
    type: "streamable-http",
    url: "https://monarch-mcp-server.quentincody.workers.dev/mcp",
    description: "Monarch Initiative — cross-species gene-phenotype-disease knowledge graph integrating OMIM, HPO, MGI, ZFIN…",
    theme: "genomics",
    category: "phenotype & disease",
    defaultEnabled: true,
  },
  {
    key: "openneuro",
    name: "OpenNeuro",
    type: "streamable-http",
    url: "https://open-neuro-mcp-server.quentincody.workers.dev/mcp",
    description: "OpenNeuro",
    theme: "genomics",
    category: "imaging & neuro",
    defaultEnabled: true,
  },
  {
    key: "orphanet",
    name: "Orphanet",
    type: "streamable-http",
    url: "https://orphanet-mcp-server.quentincody.workers.dev/mcp",
    description: "Orphanet — 6000+ rare diseases with prevalence, inheritance, gene associations, age of onset, classifications",
    theme: "genomics",
    category: "phenotype & disease",
    defaultEnabled: true,
  },
  {
    key: "phewas",
    name: "PheWAS (5 cohorts)",
    type: "streamable-http",
    url: "https://phewas-mcp-server.quentincody.workers.dev/mcp",
    description: "Multi-cohort PheWAS — FinnGen, UKB-TOPMed, BioBank Japan, TPMI, Genebass behind one variant-level interface.",
    theme: "genomics",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "rcsb-pdb",
    name: "RCSB PDB",
    type: "streamable-http",
    url: "https://rcsb-pdb-mcp-server.quentincody.workers.dev/mcp",
    description: "RCSB PDB",
    theme: "genomics",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "rnacentral",
    name: "RNAcentral",
    type: "streamable-http",
    url: "https://rnacentral-mcp-server.quentincody.workers.dev/mcp",
    description: "RNAcentral — non-coding RNA sequence database (URS accessions), cross-references, annotations.",
    theme: "genomics",
    category: "expression",
    defaultEnabled: true,
  },
  {
    key: "string-db",
    name: "STRING",
    type: "streamable-http",
    url: "https://string-mcp-server.quentincody.workers.dev/mcp",
    description: "STRING database — protein-protein interaction networks, functional enrichment (GO/KEGG), PPI statistics",
    theme: "genomics",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "ucsc",
    name: "UCSC Genome Browser",
    type: "streamable-http",
    url: "https://ucsc-mcp-server.quentincody.workers.dev/mcp",
    description: "UCSC Genome Browser API — assemblies, tracks, sequence fetching, genome search. Rate limit 10k/day per IP; no…",
    theme: "genomics",
    category: "genomics",
    defaultEnabled: true,
  },
  {
    key: "uniprot",
    name: "UniProt",
    type: "streamable-http",
    url: "https://uniprot-mcp-server.quentincody.workers.dev/mcp",
    description: "UniProt",
    theme: "genomics",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "zincbind",
    name: "ZincBind",
    type: "streamable-http",
    url: "https://zincbind-mcp-server.quentincody.workers.dev/mcp",
    description: "ZincBind",
    theme: "genomics",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "dolthub",
    name: "DoltHub",
    type: "streamable-http",
    url: "https://dolthub-mcp-server.quentincody.workers.dev/mcp",
    description: "DoltHub — version-controlled SQL databases: query community-maintained biomedical datasets with full commit history and diffs.",
    theme: "genomics",
    category: "literature & data",
    defaultEnabled: true,
  },
];
